import React from 'react';
import ApiBackfillSection from './ApiBackfillSection';
import EarningsGrid from './EarningsGrid';

/**
 * Data tab for Company Research.
 *
 * Focused on structured earnings data only.
 */
export default function ResearchDataTab({ companyId, company, earnings, onRefresh }) {

  return (
    <div className="p-3">
      {company && (
        <ApiBackfillSection
          company={company}
          onComplete={() => { if (onRefresh) onRefresh(); }}
        />
      )}

      {/* Structured earnings table */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="fw-bold mb-0">Structured Earnings Data</h6>
      </div>
      <EarningsGrid companyId={companyId} rows={earnings} onRefresh={onRefresh} />
    </div>
  );
}

